import { Lock, Unlock } from 'lucide-react'
import Swal from 'sweetalert2';
import api from '../api';

export default function AuthorizationIcon({ id, professionalCpf, professionalName, authorized, count }) {
  const resendSms = async () => {
    const result = await Swal.fire({
      title: 'Reenviar SMS?',
      text: 'Deseja reenviar o SMS de autorização para o paciente?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sim, enviar',
      cancelButtonText: 'Cancelar'
    });

    if (result.isConfirmed) {
      await api.post('api/consent/send-sms-budget', {
        budget_id: id,
        scope: "uso-dados-pessoais",
        professional_cpf: professionalCpf,
        professional_name: professionalName
      })
        .then(response => {
          Swal.fire({
            toast: true,
            position: 'top',
            icon: 'success',
            title: 'SMS enviado para o paciente',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true
          });

        })
        .catch(error => {
          Swal.fire({
            toast: true,
            position: 'top',
            icon: 'error',
            title: 'Erro ao enviar SMS para o paciente.',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true
          });

          console.error(error);
        })
    }
  }


  return (
    <div
      className="position-relative d-inline-flex align-items-center justify-content-center rounded-circle border"
      style={{
        width: "60px",
        height: "60px",
        borderColor: "#ccc",
        borderWidth: "2px",
      }}
      title={authorized ? 'Autorizado' : `Não autorizado: Clique para reenviar SMS.`}
      onClick={resendSms}
    >

      {
        authorized ?
          <Unlock size={32} />
          :
          <Lock size={32} />
      }

      {(count && count > 0 && !authorized) && (
        <span
          className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
          style={{
            fontSize: "0.8rem",
            padding: "6px 8px",
            transform: "translate(-40%, 40%)",
          }}
        >
          {count}
        </span>
      )}
    </div>
  );
}